export const packagesInfo = [
  {
    id: 1,
    title: "پکیج آزمایشی",
    bgColor: "#F2CFEF",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="145"
        height="145"
        viewBox="0 0 145 145"
        fill="none"
      >
        <path
          d="M76.0704 125.439C74.0209 126.162 70.6454 126.162 68.5959 125.439C51.1153 119.472 12.0553 94.5768 12.0553 52.3823C12.0553 33.7565 27.0645 18.687 45.5698 18.687C56.5403 18.687 66.2451 23.9915 72.3331 32.1892C78.4212 23.9915 88.1862 18.687 99.0965 18.687C117.602 18.687 132.611 33.7565 132.611 52.3823C132.611 94.5768 93.5509 119.472 76.0704 125.439Z"
          stroke="#A02B93"
          stroke-width="9.04168"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    absIcon: (
      <svg
        className={`absolute right-0 top-0 z-0 max-md:size-[100px]`}
        xmlns="http://www.w3.org/2000/svg"
        width="149"
        height="151"
        viewBox="0 0 149 151"
        fill="none"
      >
        <circle
          cx="115.405"
          cy="34.8137"
          r="91.1096"
          stroke="url(#paint0_radial_8270_2390)"
          stroke-width="48.5918"
        />
        <defs>
          <radialGradient
            id="paint0_radial_8270_2390"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(48.5918 20.8435) rotate(44.3069) scale(213.045)"
          >
            <stop stop-color="#F3C5EE" />
            <stop offset="1" stop-color="#A02B93" />
          </radialGradient>
        </defs>
      </svg>
    ),
    bannerColor: "#A02B93",
    specs: ["۱ دسته بندی چالش", " حداکثر ۵ کاربر"],
    price: 0,
  },
  {
    id: 2,
    title: "پکیج برنزی",
    bgColor: "#FADFC3",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="161"
        height="161"
        viewBox="0 0 161 161"
        fill="none"
      >
        <path
          d="M93.1202 24.0725L104.923 47.6773C106.532 50.9632 110.824 54.115 114.445 54.7185L135.837 58.2727C149.517 60.5527 152.736 70.4774 142.878 80.268L126.247 96.8987C123.431 99.7152 121.889 105.147 122.76 109.036L127.522 129.624C131.277 145.919 122.626 152.222 108.209 143.706L88.1578 131.836C84.5366 129.691 78.5684 129.691 74.8801 131.836L54.8295 143.706C40.4788 152.222 31.7611 145.852 35.5164 129.624L40.2776 109.036C41.1494 105.147 39.607 99.7152 36.7906 96.8987L20.1599 80.268C10.3693 70.4774 13.5211 60.5527 27.2011 58.2727L48.593 54.7185C52.1471 54.115 56.4389 50.9632 58.0483 47.6773L69.8507 24.0725C76.2884 11.2642 86.7496 11.2642 93.1202 24.0725Z"
          stroke="#C4782A"
          stroke-width="10.0589"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    absIcon: (
      <svg
        className={`absolute right-0 top-0 z-0 max-md:size-[100px]`}
        xmlns="http://www.w3.org/2000/svg"
        width="162"
        height="169"
        viewBox="0 0 162 169"
        fill="none"
      >
        <circle
          cx="115.405"
          cy="53.4509"
          r="91.1096"
          stroke="url(#paint0_radial_8270_2212)"
          stroke-width="48.5918"
        />
        <defs>
          <radialGradient
            id="paint0_radial_8270_2212"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(48.5918 39.4807) rotate(44.3069) scale(213.045)"
          >
            <stop stop-color="#FADEC3" />
            <stop offset="1" stop-color="#BF9163" />
          </radialGradient>
        </defs>
      </svg>
    ),

    bannerColor: "#C4782A",
    specs: ["۵ دسته بندی چالش", " حداکثر 10 کاربر"],
    price: "2,400,000 تومان",
  },
  {
    id: 3,
    title: "پکیج نقره ای",
    bgColor: "#E3E5EC",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="174"
        height="174"
        viewBox="0 0 174 174"
        fill="none"
      >
        <path
          d="M86.8003 108.5C113.766 108.5 135.625 87.4496 135.625 61.483C135.625 35.5164 113.766 14.4663 86.8003 14.4663C59.8349 14.4663 37.9752 35.5164 37.9752 61.483C37.9752 87.4496 59.8349 108.5 86.8003 108.5Z"
          stroke="#858588"
          stroke-width="10.85"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M54.3938 97.7951L54.3217 151.177C54.3217 157.687 58.8787 160.87 64.5207 158.194L83.906 149.007C85.4973 148.212 88.1736 148.212 89.765 149.007L109.223 158.194C114.792 160.798 119.422 157.687 119.422 151.177V96.4932"
          stroke="#858588"
          stroke-width="10.85"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    absIcon: (
      <svg
        className={`absolute right-0 top-0 z-0 max-md:size-[100px]`}
        xmlns="http://www.w3.org/2000/svg"
        width="162"
        height="169"
        viewBox="0 0 162 169"
        fill="none"
      >
        <circle
          cx="115.405"
          cy="53.4509"
          r="91.1096"
          stroke="url(#paint0_radial_8270_2226)"
          stroke-width="48.5918"
        />
        <defs>
          <radialGradient
            id="paint0_radial_8270_2226"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(48.5918 39.4807) rotate(45) scale(176.093)"
          >
            <stop stop-color="#E3E5EC" />
            <stop offset="1" stop-color="#CED0D6" />
          </radialGradient>
        </defs>
      </svg>
    ),

    bannerColor: "#858587",
    specs: ["۱۰ دسته بندی چالش", " حداکثر 20 کاربر"],
    price: "4,900,000 تومان",
  },
  {
    id: 4,
    title: "پکیج طلایی",
    bgColor: "#FFEFC4",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="195"
        height="195"
        viewBox="0 0 195 195"
        fill="none"
      >
        <path
          d="M153.883 72.8911C153.883 84.6349 150.401 95.4068 144.407 104.397C135.66 117.355 121.811 126.507 105.693 128.856C102.94 129.342 100.105 129.585 97.1893 129.585C94.2737 129.585 91.439 129.342 88.6853 128.856C72.568 126.507 58.7185 117.355 49.9715 104.397C43.9781 95.4068 40.4955 84.6349 40.4955 72.8911C40.4955 41.5475 65.8457 16.1973 97.1893 16.1973C128.533 16.1973 153.883 41.5475 153.883 72.8911Z"
          stroke="#D3B155"
          stroke-width="12.1487"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M172.107 149.591L158.744 152.749C155.747 153.478 153.398 155.746 152.75 158.743L149.916 170.648C148.377 177.128 140.116 179.072 135.823 173.969L97.1903 129.586L58.5575 174.05C54.265 179.152 46.0039 177.209 44.465 170.729L41.6303 158.824C40.9014 155.827 38.5527 153.478 35.637 152.83L22.2734 149.672C16.1181 148.214 13.9313 140.52 18.3858 136.065L49.9724 104.479C58.7195 117.437 72.569 126.589 88.6862 128.938C91.4399 129.424 94.2746 129.667 97.1903 129.667C100.106 129.667 102.941 129.424 105.694 128.938C121.812 126.589 135.661 117.437 144.408 104.479L175.995 136.065C180.449 140.439 178.263 148.133 172.107 149.591Z"
          stroke="#D3B155"
          stroke-width="12.1487"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M101.886 48.4325L106.665 57.9894C107.313 59.2853 109.014 60.5812 110.552 60.8241L119.219 62.2819C124.726 63.1728 126.022 67.2224 122.053 71.191L115.331 77.9132C114.197 79.0471 113.549 81.2339 113.954 82.8538L115.898 91.1959C117.437 97.7562 113.954 100.348 108.123 96.8651L100.024 92.0866C98.5658 91.1957 96.136 91.1957 94.6782 92.0866L86.5791 96.8651C80.7477 100.267 77.2651 97.7562 78.8039 91.1959L80.7477 82.8538C81.0717 81.3149 80.5047 79.0471 79.3708 77.9132L72.6486 71.191C68.68 67.2224 69.9759 63.2538 75.4833 62.2819L84.1493 60.8241C85.6072 60.5812 87.308 59.2853 87.9559 57.9894L92.7344 48.4325C95.0831 43.2491 99.2947 43.2491 101.886 48.4325Z"
          stroke="#D3B155"
          stroke-width="12.1487"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    absIcon: (
      <svg
        className={`absolute right-0 top-0 z-0 max-md:size-[100px]`}
        xmlns="http://www.w3.org/2000/svg"
        width="162"
        height="169"
        viewBox="0 0 162 169"
        fill="none"
      >
        <circle
          cx="115.405"
          cy="53.4509"
          r="91.1096"
          stroke="url(#paint0_radial_8270_2241)"
          stroke-width="48.5918"
        />
        <defs>
          <radialGradient
            id="paint0_radial_8270_2241"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(48.5918 39.4807) rotate(45) scale(162.349)"
          >
            <stop stop-color="#FFEFC4" />
            <stop offset="1" stop-color="#CBA53F" />
          </radialGradient>
        </defs>
      </svg>
    ),
    bannerColor: "#D3B155",
    specs: ["15 دسته بندی چالش", " حداکثر 50 کاربر"],
    price: "9,900,000 تومان",
  },
  {
    id: 5,
    title: "پکیج پلاتینیوم",
    bgColor: "#EEEAE0",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="195"
        height="195"
        viewBox="0 0 195 195"
        fill="none"
      >
        <path
          d="M153.883 72.8911C153.883 84.6349 150.401 95.4068 144.407 104.397C135.66 117.355 121.811 126.507 105.693 128.856C102.94 129.342 100.105 129.585 97.1893 129.585C94.2737 129.585 91.439 129.342 88.6853 128.856C72.568 126.507 58.7185 117.355 49.9715 104.397C43.9781 95.4068 40.4955 84.6349 40.4955 72.8911C40.4955 41.5475 65.8457 16.1973 97.1893 16.1973C128.533 16.1973 153.883 41.5475 153.883 72.8911Z"
          stroke="#8D8B86"
          stroke-width="12.1487"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M172.107 149.591L158.744 152.749C155.747 153.478 153.398 155.746 152.75 158.743L149.915 170.648C148.377 177.128 140.116 179.072 135.823 173.969L97.1902 129.586L58.5574 174.05C54.2648 179.152 46.0037 177.209 44.4649 170.729L41.6302 158.824C40.9013 155.827 38.5525 153.478 35.6369 152.83L22.2733 149.672C16.118 148.214 13.9312 140.52 18.3857 136.065L49.9723 104.479C58.7194 117.437 72.5689 126.589 88.6861 128.938C91.4398 129.424 94.2745 129.667 97.1902 129.667C100.106 129.667 102.941 129.424 105.694 128.938C121.812 126.589 135.661 117.437 144.408 104.479L175.995 136.065C180.449 140.439 178.262 148.133 172.107 149.591Z"
          stroke="#8D8B86"
          stroke-width="12.1487"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M101.886 48.4325L106.665 57.9894C107.313 59.2853 109.014 60.5812 110.552 60.8241L119.218 62.2819C124.726 63.1728 126.022 67.2224 122.053 71.191L115.331 77.9132C114.197 79.0471 113.549 81.2339 113.954 82.8538L115.898 91.1959C117.437 97.7562 113.954 100.348 108.123 96.8651L100.023 92.0866C98.5656 91.1957 96.1359 91.1957 94.6781 92.0866L86.5789 96.8651C80.7476 100.267 77.2649 97.7562 78.8038 91.1959L80.7476 82.8538C81.0715 81.3149 80.5046 79.0471 79.3707 77.9132L72.6485 71.191C68.6799 67.2224 69.9757 63.2538 75.4831 62.2819L84.1492 60.8241C85.607 60.5812 87.3079 59.2853 87.9558 57.9894L92.7343 48.4325C95.083 43.2491 99.2946 43.2491 101.886 48.4325Z"
          stroke="#8D8B86"
          stroke-width="12.1487"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    absIcon: (
      <svg
        className={`absolute right-0 top-0 z-0 max-md:size-[100px]`}
        xmlns="http://www.w3.org/2000/svg"
        width="162"
        height="169"
        viewBox="0 0 162 169"
        fill="none"
      >
        <circle
          cx="115.405"
          cy="53.4509"
          r="91.1096"
          stroke="url(#paint0_radial_8270_2257)"
          stroke-width="48.5918"
        />
        <defs>
          <radialGradient
            id="paint0_radial_8270_2257"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(48.5918 39.4807) rotate(45) scale(162.349)"
          >
            <stop stop-color="#DBD7CB" />
            <stop offset="1" stop-color="#AAA28D" />
          </radialGradient>
        </defs>
      </svg>
    ),
    bannerColor: "#8D8B86",
    specs: ["20 دسته بندی چالش", " حداکثر 100 کاربر"],
    price: "19,900,000 تومان",
  },
  {
    id: 6,
    title: "پکیج سبز",
    bgColor: "#DAF2D0",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="195"
        height="195"
        viewBox="0 0 195 195"
        fill="none"
      >
        <path
          d="M153.883 72.8911C153.883 84.6349 150.401 95.4068 144.407 104.397C135.66 117.355 121.811 126.507 105.693 128.856C102.94 129.342 100.105 129.585 97.1893 129.585C94.2737 129.585 91.439 129.342 88.6853 128.856C72.568 126.507 58.7185 117.355 49.9715 104.397C43.9781 95.4068 40.4955 84.6349 40.4955 72.8911C40.4955 41.5475 65.8457 16.1973 97.1893 16.1973C128.533 16.1973 153.883 41.5475 153.883 72.8911Z"
          stroke="#0D9D69"
          stroke-width="12.1487"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M172.107 149.591L158.744 152.749C155.747 153.478 153.398 155.746 152.75 158.743L149.915 170.648C148.377 177.128 140.116 179.072 135.823 173.969L97.1902 129.586L58.5574 174.05C54.2648 179.152 46.0037 177.209 44.4649 170.729L41.6302 158.824C40.9013 155.827 38.5525 153.478 35.6369 152.83L22.2733 149.672C16.118 148.214 13.9312 140.52 18.3857 136.065L49.9723 104.479C58.7194 117.437 72.5689 126.589 88.6861 128.938C91.4398 129.424 94.2745 129.667 97.1902 129.667C100.106 129.667 102.941 129.424 105.694 128.938C121.812 126.589 135.661 117.437 144.408 104.479L175.995 136.065C180.449 140.439 178.262 148.133 172.107 149.591Z"
          stroke="#0D9D69"
          stroke-width="12.1487"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M101.886 48.4325L106.665 57.9894C107.313 59.2853 109.014 60.5812 110.552 60.8241L119.218 62.2819C124.726 63.1728 126.022 67.2224 122.053 71.191L115.331 77.9132C114.197 79.0471 113.549 81.2339 113.954 82.8538L115.898 91.1959C117.437 97.7562 113.954 100.348 108.123 96.8651L100.023 92.0866C98.5656 91.1957 96.1359 91.1957 94.6781 92.0866L86.5789 96.8651C80.7476 100.267 77.2649 97.7562 78.8038 91.1959L80.7476 82.8538C81.0715 81.3149 80.5046 79.0471 79.3707 77.9132L72.6485 71.191C68.6799 67.2224 69.9757 63.2538 75.4831 62.2819L84.1492 60.8241C85.607 60.5812 87.3079 59.2853 87.9558 57.9894L92.7343 48.4325C95.083 43.2491 99.2946 43.2491 101.886 48.4325Z"
          stroke="#0D9D69"
          stroke-width="12.1487"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    absIcon: (
      <svg
        className={`absolute right-0 top-0 z-0 max-md:size-[100px]`}
        xmlns="http://www.w3.org/2000/svg"
        width="162"
        height="169"
        viewBox="0 0 162 169"
        fill="none"
      >
        <circle
          cx="115.405"
          cy="53.4509"
          r="91.1096"
          stroke="url(#paint0_radial_8270_2273)"
          stroke-width="48.5918"
        />
        <defs>
          <radialGradient
            id="paint0_radial_8270_2273"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(48.5918 39.4807) rotate(45) scale(162.349)"
          >
            <stop stop-color="#F3FFFB" />
            <stop offset="1" stop-color="#4EA72F" />
          </radialGradient>
        </defs>
      </svg>
    ),
    bannerColor: "#0D9D69",
    specs: ["25 دسته بندی چالش", "تعداد کاربر نامحدود"],
    price: "39,900,000 تومان",
  },
];
